import React from 'react';
import styles from './reviewSearchAndKeywordsStyles.module.scss';
import ReviewAIKeywords from './ReviewAIKeywords';
import ReviewsSearchInput from './ReviewsSearchInput';
import { useMediaQuery } from '@material-ui/core';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';

const ReviewsSearchAndKeywords = ({
  keywords,
  activeKeyword,
  setActiveKeyword,
  searchTerm,
  setSearchTerm,
}: {
  keywords: string[] | null;
  activeKeyword: string | undefined;
  setActiveKeyword: React.Dispatch<React.SetStateAction<string | undefined>>;
  searchTerm: string | undefined;
  setSearchTerm: React.Dispatch<React.SetStateAction<string | undefined>>;
}) => {
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT);
  return (
    <div className={styles.reviewSearchAndKeywords}>
      <h6 className={`${isMobile ? 'body semibold' : 'editorial'} notranslate`}>Filter Reviews</h6>
      <ReviewsSearchInput searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <ReviewAIKeywords keywords={keywords} activeKeyword={activeKeyword} setActiveKeyword={setActiveKeyword} />
    </div>
  );
};

export default ReviewsSearchAndKeywords;
